// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"0934128f","710":"0934128f"}[chunkId] + ".chunk.css";
};